// import home from '../../api/home'
import http from '../../httpuntil'

// initial state
const state = {
    projects: [],
    categories: [],
    advertisements:[],
    selectedCategoryID:0,
}

// getters
const getters = {
  projectsQTY: state => {
    return state.projects.length;
  }
}

// actions
const actions = {
 
  getAdvertisement:function({commit}){
    return new Promise ( (resolve, reject ) => {
      http.get("/api/advertisement/get",(data)=>{
        if (data.Success) {
          commit('setAdvertisement', data.Data);
          resolve();
        }
      },(e)=>{
          console.log(e);
      });
    });
  }
}

// mutations
const mutations = {
  setAdvertisement (state, advertisements) {
    state.advertisements = advertisements
  },
  setSelectedCategoryID (state, id) {
    state.selectedCategoryID = id
  }
}

export default {
  namespaced: true,
  state,// 共同维护的一个状态，state里面可以是很多个全局状态
  getters,// 获取数据并渲染
  actions,// 数据的异步操作
  mutations// 处理数据的唯一途径，state的改变或赋值只能在这里
}